import { useCallback } from 'react';
import { LD_JSON_HEADERS, useApiCall } from './apiHelpers';

export interface CreateOfferInputPayload {
  communicationInput: string;
  title?: string;
  description?: string;
  offerNumber?: string;
  startValidityDate?: string;
  endValidityDate?: string;
  nbMaxEdit?: number;
  nbMaxUse?: number;
  refDiscountTypeId?: number;
  payloadRefDiscountType?: object;
  refEditConditionId?: number;
  payloadRefEditCondition?: object;
  refUseConditionId?: number;
  payloadRefUseCondition?: object;
}

const useCreateOfferInput = () => {
  const { authFetch, isReady, run } = useApiCall();

  const createOfferInput = useCallback(
    async (payload: CreateOfferInputPayload): Promise<{ id: number } | null> => {
      if (!isReady) return null;
      const outcome = await run<{ id: number }>(
        () => authFetch('/offer_inputs', { method: 'POST', headers: LD_JSON_HEADERS, body: JSON.stringify(payload) }),
        "Erreur lors de la création de l'offre",
      );
      return outcome.ok ? outcome.data : null;
    },
    [authFetch, isReady, run],
  );

  return { createOfferInput };
};

export default useCreateOfferInput;
